import { Controller } from "@hotwired/stimulus"

// Collapse controller for collapsible card elements
export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Set initial state
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180", this.isCollapsed)
    }
  }

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    
    // Rotate icon if present
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }
  }
  
  get isCollapsed() {
    return this.contentTarget.classList.contains("hidden")
  }
}